import React, { useState } from 'react';
import { Container, Card, Button, Spinner, Row, Col } from 'react-bootstrap';
import axios from 'axios';

function Page1() {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const [pageUrl, setPageUrl] = useState('');

  const handleGenerateQrCode = async () => {
    const imageBlob = await fetch('/images/image3.jpg').then(res => res.blob());

    const formData = new FormData();

    formData.append('title', 'Card Title 3');
    formData.append('description', 'Some quick example text to build on the card title and make up the bulk of the card\'s content page 2 description.');
    formData.append('image', imageBlob, 'image3.jpg'); // Send image as a file (filename is 'image3.jpg')

    setLoading(true); // Show loader

    try {
      const response = await axios.post('https://qrkey.qrkey.info/api/create-page', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log('Response:', response.data); // Log the API response

      setImageUrl(response.data.page_url);
      setQrCodeUrl(response.data.qr_code_url);
      setPageUrl(response.data.page_url);
    } catch (error) {
      console.error('Error:', error); // Log any errors
    } finally {
      setLoading(false); // Hide loader after response
    }
  };

    const handleDownloadImage = () => {
        const downloadUrl = `https://qrkey.qrkey.info/download-image?image_url=${encodeURIComponent(qrCodeUrl)}`;
        window.open(downloadUrl, '_blank');
  };

  return (
    <Container className="mt-4">
      <Row>
        <Col sm={12} md={6} lg={4}>
            <Card style={{ width: '100%' }}>
                <Card.Body>
                <Card.Title>Card Title 3</Card.Title>
                <Card.Text>
                    Some quick example text to build on the card title and make up the
                    bulk of the card's content page 2 description.
                </Card.Text>
                <Card.Img src="/images/image3.jpg" alt="Card image" />
                </Card.Body>
                <Button
                variant="primary"
                onClick={handleGenerateQrCode}
                disabled={loading}
                >
                {loading ? (
                    <>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                    />{' '}
                    Generating...
                    </>
                ) : (
                    'Generate QRCode'
                )}
                </Button>
            </Card>
        </Col>

        {pageUrl && (
          <Col sm={12} md={6} lg={4}> {/* Bootstrap grid column sizes */}
            <Card className="mt-4" style={{ width: '100%' }}>
              <Card.Body>
                <Card.Title>Generated Page Url QR Code</Card.Title>
                <Card.Img
                  src={qrCodeUrl}
                  alt="Generated Page QR Code"
                  style={{ width: '150px', height: '200px', objectFit: 'contain' }}
                />
                <Button variant="primary" onClick={handleDownloadImage}>
                  Download
                </Button>
              </Card.Body>
            </Card>
          </Col>
        )}
      </Row>
    </Container>
  );
}

export default Page1;
